<template>
  <div :style="styles"></div>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: "s",
    },
    borderTop: {
      type: Boolean,
      default: false,
    },
    borderBottom: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    styles() {
      let height = 0;
      switch (this.size) {
        case "s":
          height = 8;
          break;
        case "m":
          height = 16;
          break;
        case "l":
          height = 24;
          break;
        case "xl":
          height = 32;
          break;
        default:
          height = 8;
          break;
      }
      return {
        width: "100%",
        height: `${height}px`,
        borderTop: this.borderTop ? '1px solid #D9D9D9' : 'none',
        borderBottom: this.borderBottom ? '1px solid #D9D9D9' : 'none',
      };
    },
  },
};
</script>

<style lang="scss" scoped></style>
